import { Component, Input, Output, EventEmitter } from '@angular/core';
import { File } from 'app/models/file';

@Component({
  selector: 'app-camera-documents-attacher',
  templateUrl: './camera-documents-attacher.component.html',
  styleUrls: ['./camera-documents-attacher.component.scss']
})
export class CameraDocumentsAttacherComponent {
  @Input() disabled: boolean;
  @Input() documents: File[];
  @Output() attach = new EventEmitter();
  @Output() delete = new EventEmitter();

  attachDocument($event) {
    this.attach.emit($event.dragData);
  }

  onRemoveFile(event) {
    this.delete.emit(event);
  }
}
